module.exports = __webpack_public_path__ + "static/img/blog_good_2.134a913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_good_2.png
// module id = 0GkI
// module chunks = 8